var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item d-flex flex-column align-items-center"},[_c('img',{attrs:{"src":_vm.img}}),_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"i_body_l"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }